import React from 'react';
import { HighlightItem } from '../../queries/homePage/highlights';
import { HighlightCardWrapper } from './HighlightCard.style';
import {
  SharpieImageConfig,
  useSharpie,
} from '../../common/helpers/sharpie/useSharpie';
import LazyImage from '../lazyImage/LazyImage';

interface HighlightCardProps {
  highlight: HighlightItem;
  onClickHighlightCard?: (highlight: HighlightItem) => void;
}

const imageSharpieConfig: SharpieImageConfig = {
  desktop: {
    width: 240,
    height: 136,
  },
  tablet: {
    width: 228,
    height: 136,
  },
  mobile: {
    width: 240,
    height: 136,
  },
};

export const HighlightCard: React.FC<HighlightCardProps> = ({
  highlight,
  onClickHighlightCard,
}) => {
  const { link, name, imageUrl } = highlight;
  const sharpieImageUrl = useSharpie(imageUrl, imageSharpieConfig, 'crop');

  return (
    <HighlightCardWrapper
      href={link}
      title={name}
      onClick={() => {
        onClickHighlightCard(highlight);
      }}
    >
      <div className="body">
        <div className="content">{name}</div>
      </div>
      <div className="image">
        <LazyImage src={sharpieImageUrl} alt={name} lazyLoad />
      </div>
    </HighlightCardWrapper>
  );
};
